// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutogrowController from "./autogrow_controller";
application.register("autogrow", AutogrowController);

import CmdEnterController from "./cmd_enter_controller";
application.register("cmd-enter", CmdEnterController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);
